export default __webpack_public_path__ + "static/resourcepack-9d9b408fcd205c68f7d9dad29c90cde2.jpg";